import React, { useRef, useState, useLayoutEffect } from 'react';
import { Spinner } from '../Spinner';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { Title } from './page-components/Title';
import { CopyComponent } from '../CopyComponent';
import { WhisperComponent } from './page-components/WhisperComponent';

interface IKeyContainerProps {
	title: string;
	value?: string;
	isVisible?: boolean;
	showPass?: boolean;
	canCopy?: boolean;
	loading?: boolean;
	isTooltipShown?: boolean;
	copyWithText?: boolean;
	additionalCopyClass?: string;
}

export const KeyContainer = (props: IKeyContainerProps): JSX.Element => {
	const { title, value= '', isVisible, loading, isTooltipShown, showPass, canCopy, copyWithText, additionalCopyClass } = props;
	const [showSecretSecret, setShowSecretSecret] = useState(isTooltipShown ? isTooltipShown : false);
	const splicedValue = value?.slice(0,4);
	const restValue = value?.slice(4);
	const changedValue = restValue?.replace(/./g, '*');

	const secretValue = splicedValue?.concat(changedValue);

	const textElementRef = useRef(null);

	const [width, setWidth] = useState(0);

	useLayoutEffect(() => {
		if (!loading) {
			setWidth(textElementRef?.current?.offsetWidth);
		}
	}, [loading]);

	if (loading) {
		return (
			<>
				<Title title={title} additionalClass="fs-2 mb-5"/>
				<div className="d-flex justify-content-between mb-10">
					<Spinner/>
				</div>
			</>
		);
	}

	return (
		<>
			<Title title={title} additionalClass="fs-2 mb-5"/>
			<div className="d-flex justify-content-between mb-10">

				<div className="fs-6 text-truncate">

					{
						!isVisible && textElementRef?.current?.scrollWidth > width ||
						showSecretSecret && textElementRef?.current?.scrollWidth > width
							? (
								<WhisperComponent
									whisperText={value}
									mainText={value}
									placement="autoVertical"
									trigger="hover"
									additionalClass={clsx('d-block fs-6 text-truncate', showSecretSecret && 'cursor-pointer')}
								/>
							)
							: (
								<span
									className="d-block fs-6 text-truncate"
									ref={textElementRef}
								>
                  {showSecretSecret || !isVisible ? value : secretValue}
                </span>
							)
					}
				</div>

				<div className="d-flex align-items-center">
					{
						showPass && value && value !== '-' && (
							<div
								className="eye-container cursor-pointer"
								onClick={(): void => showSecretSecret ? setShowSecretSecret(false) : setShowSecretSecret(true)}
							>
								<FontAwesomeIcon icon={showSecretSecret ? faEye : faEyeSlash}/>
							</div>
						)
					}
					{
						canCopy && value && value !== '-' && (
							<CopyComponent
								value={value}
								title={title}
								withText={copyWithText}
								additionalClass={additionalCopyClass}
							/>
						)
					}
				</div>
			</div>
		</>
	);
};
